import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { slugify, unslugify } from '../utils/slugify';
import SEO from '../components/SEO';

function Implants() {
    const [data, setData] = useState([]);
    const { categoryName } = useParams();
    const location = useLocation();
    const [product] = useState(location.state?.product || null);

    const decodedCategory = unslugify(categoryName || product?.categoryName || 'Implants');

    const getApiData = async () => {
        try {
            const res = await axios.get("https://api.sofiasurgicals.com/api/all-inplants");
            const filterData = res.data?.data || [];
            const filterInplants = filterData.filter(
                (x) => unslugify(x.categoryName?.categoryName)?.toLowerCase() === decodedCategory.toLowerCase()
            );
            setData(filterInplants);
        } catch (error) {
            console.error("Error fetching implants:", error);
        }
    };

    useEffect(() => {
        getApiData();
    }, [categoryName, product]);

    return (
        <>
            <SEO
                title={`${decodedCategory} Implants`}
                description={`Explore high-quality ${decodedCategory} orthopaedic implants by Sofia Surgicals India. ISO and CE certified medical manufacturing.`}
                keywords={`${decodedCategory}, orthopaedic implants, trauma implants, surgical implants India`}
                url={`/Implants/${categoryName}`}
            />
            <section className="implants">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ourproduct">
                                <h2 className="product">
                                    Implants {decodedCategory && `— ${decodedCategory}`}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {
                data.length > 0 ?
                    <section className="implants">
                        <div className="container">
                            <div className="row mt-1 py-4 implants-card">
                                {data.map((implant, index) => (
                                    <div className="col-md-3" key={index}>
                                        <div className="category-card">
                                            <Link to={`/implants-details/${slugify(implant.inplantsName)}`}
                                                state={{ implant }}
                                                className='text-decoration-none'
                                            >
                                                <img alt={implant.inplantsName} className="img-fluid" src={`https://api.sofiasurgicals.com/${implant.inplantsImage}`} width="250" height="230" />
                                                <div className="category-title text-dark">
                                                    {implant.inplantsName}
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section> : <p className='text-uppercase mb-5 mt-5 text-center fs-2'>No implants found for this category.</p>
            }
        </>
    );
}

export default Implants;
